import React from 'react';

import LinkFreeStanding from 'elements/Link/LinkFreeStanding/LinkFreeStanding';
import LinkWidget from 'elements/Link/LinkWidget/LinkWidget';
import LinkWithinText from 'elements/Link/LinkWithinText/LinkWithinText';
import LinkHeading from 'elements/Link/LinkHeading/LinkHeading';
import LinkAction from 'elements/Link/LinkAction/LinkAction';

const getIcon = (size, direction) => {
  const sizeMap = {
    xl: {
      direction: `${direction}`,
      name: `link-arrow-${direction}`,
      type: '30'
    },
    l: {
      direction: `${direction}`,
      name: `arrow-${direction}`,
      type: '20'
    },
    m: {
      direction: `${direction}`,
      name: `arrow-${direction}`,
      type: '20'
    },
    s: {
      direction: `${direction}`,
      name: `link-arrow-${direction}-17`,
      type: 'other'
    },
    xs: {
      direction: `${direction}`,
      name: `link-arrow-${direction}-17`,
      type: 'other'
    }
  };

  return sizeMap[size];
};

const sizes = {
  xl: '20px',
  l : '16px',
  m : '14px',
  s : '12px',
  xs: '11px',
};

const prevendDefaults = (e) => e.preventDefault();

/* eslint-disable react/prop-types */
export const FreeStanding = ({ dark, iconDirection, size }) => {

  const icon = iconDirection && getIcon(size, iconDirection);

  return <LinkFreeStanding withBouncing icon={icon} dark={dark} size={size} onClick={prevendDefaults}>FREESTANDING</LinkFreeStanding>;
};

export const Widgets = ({ iconDirection, size }) => {

  const icon = iconDirection && getIcon(size, iconDirection);

  return <LinkWidget withBouncing icon={icon} size={size} onClick={prevendDefaults}>WIDGETS</LinkWidget>;
};

export const WithinText = ({ secondaryLight, secondaryDark, size, medium, dark }) => {
  const styles = { fontSize: sizes[size] };

  return(
    <p className="large" style={styles}>this is a&nbsp;
    <LinkWithinText
      size={size}
      secondaryLight={secondaryLight}
      secondaryDark={secondaryDark}
      medium={medium}
      dark={dark}
      onClick={prevendDefaults}
    >LINK</LinkWithinText>
    &nbsp;within text</p>);
};

export const Heading = ({ size }) => (
  <LinkHeading size={size} onClick={prevendDefaults}>heading</LinkHeading>
);

export const Action = ({ size, dark }) => (
  <LinkAction size={size} dark={dark} onClick={prevendDefaults}>action</LinkAction>
);
/* eslint-enable react/prop-types */



// WEBPACK FOOTER //
// ./src/containers/elements/Links/constants/linksLayouts.js